export const promotionalOrdersApi = {
    getAll () {
        return axios.get(`/api/digital`)
    },

    getById (order_id) {
        return axios.get(`/api/digital/${order_id}`)
    },
}
